import type { ProviderFactoryConfig, ProviderFactoryWithOptions, ProviderConfigSlots } from '@standardagents/spec';
import { NovitaProvider } from './NovitaProvider';
import { novitaProviderOptions } from './providerOptions';

/**
 * Novita AI provider factory for Standard Agents.
 *
 * Uses Novita's OpenAI-compatible Chat Completions API and live model catalog.
 */
export const novita: ProviderFactoryWithOptions<typeof novitaProviderOptions> =
  Object.assign(
    (config: ProviderFactoryConfig) => new NovitaProvider(config),
    {
      providerOptions: novitaProviderOptions,
      configSlots: {
        apiKey: {
          type: 'secret',
          required: true,
          defaultEnv: 'NOVITA_API_KEY',
          overridable: true,
          description: 'Novita AI API key used to authenticate provider requests.',
        },
        baseUrl: {
          type: 'url',
          required: false,
          default: 'https://api.novita.ai/openai/v1',
          overridable: true,
          description: 'Novita OpenAI-compatible API base URL.',
        },
        timeout: {
          type: 'number',
          required: false,
          default: 30000,
          overridable: true,
          description: 'Provider request timeout in milliseconds.',
        },
      } satisfies ProviderConfigSlots,
    }
  );

export { novitaProviderOptions, type NovitaProviderOptions } from './providerOptions';
export {
  NovitaProvider,
  normalizeNovitaPricePerMillion,
  novitaUsagePricingFromModel,
  calculateNovitaUsageCost,
  type NovitaModelInfo,
} from './NovitaProvider';
